<template>
  <div class="pane-container" :class="{ compact }">
    <div class="header">
      <div>
        <BaseNav v-if="hasNav" class="nav" />
      </div>
      <div class="right">
        <slot name="right">
          <BaseToggleLeftPaneButton v-if="isHideable" class="icon" />
        </slot>
      </div>
    </div>
    <div class="main">
      <div class="content">
        <slot />
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent } from "vue";

import BaseNav from "@/components/base/BaseNav.vue";

import BaseToggleLeftPaneButton from "./BaseToggleLeftPaneButton.vue";

export default defineComponent({
  components: {
    BaseNav,
    BaseToggleLeftPaneButton,
  },
  props: {
    hasNav: { type: Boolean, default: true },
    isHideable: { type: Boolean, default: true },
    compact: { type: Boolean, default: false },
  },
});
</script>
<style lang="scss" scoped>
.pane-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 100px;
  flex-shrink: 0;
  @include themed() {
    border-bottom: 1px solid t($grey-15);
  }

  &.compact {
    min-height: 0;
    border-bottom: none;

    .main {
      padding: 0;
      @include themed() {
        color: t($primary);
      }
    }
  }

  .header {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-items: center;
    justify-content: space-between;
    z-index: $z-index-pane-header-high;
    padding: 8px 12px;
    -webkit-user-select: none;
    user-select: none;
    -webkit-app-region: no-drag;

    .spacer {
      display: flex;
      flex: 1;
    }

    .right {
      display: flex;
      flex-direction: row;
    }
  }

  .main {
    display: flex;
    align-items: flex-end;
    justify-items: center;
    text-transform: uppercase;
    padding: 0 16px 10px 16px;
    @extend %font-small-regular;
    @include themed() {
      color: t($grey-40);
    }

    .content {
      display: flex;
      flex: 1;
      align-items: center;
      justify-items: center;
      width: 100%;
    }
  }
}
</style>
